import React, { useEffect } from "react"
import Breadcrumbs from "components/Common/Breadcrumb"
import { Card, CardBody, CardTitle, Col, Row, Table } from "reactstrap"
import { useLocation, useNavigate } from "react-router-dom"
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import { getAdminUserDetails } from "store/actions/usersAction"
import Spinners from "components/Shared/Spinners"
import BackButton from "components/Shared/BackButton"
import isPermissionEnabled from "common/isPermissionEnabled"
import { useTranslation } from "react-i18next"
import LtrText from "components/Shared/LtrText"

const ViewUser = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation()

  document.title = t("User Details ")
  const location = useLocation()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const searchParams = new URLSearchParams(location.search)
  const id = searchParams.get("id")

  const { userRole, accountType, accountScope } = useSelector(state => state.Login)
  const isSuperAdminSession =
    accountScope === "super_admin" || accountType === "superadmin"

  useEffect(() => {
    const usersCategoryId = isSuperAdminSession ? 103 : 6
    const viewPermissionId = isSuperAdminSession
      ? "sa_users_1"
      : "usersPermission_1"
    const isPermissionView = isPermissionEnabled(
      userRole,
      usersCategoryId,
      viewPermissionId,
      accountType,
      accountScope
    )
    if (!isPermissionView) {
      navigate("/dashboard")
    }
  }, [userRole, accountType, accountScope, isSuperAdminSession, navigate])

  const { loading, userDetails } = useSelector(state => state.Users)

  useEffect(() => {
    const getUserDetails = () => {
      const payload = {
        id,
      }
      dispatch(getAdminUserDetails(payload))
    }

    getUserDetails()
  }, [])

  // GET THE TOTAL LENGTH OF ALL LOCATIONS
  // useEffect(() => {
  //   if (userDetails?.locations) {
  //     const updatedMiniCards = miniCards.map(card =>
  //       card.id === 1 ? { ...card, text: userDetails?.locations?.length } : card
  //     )
  //     setMiniCards(updatedMiniCards)
  //   }
  // }, [userDetails])

  // useEffect(() => {
  //   if (userDetails?.role?.permissions) {
  //     const permissions = userDetails?.role?.permissions
  //     let enabledPermissionGroupsCount = 0
  //     const enabledPermissionsCount = permissions.filter(
  //       permission => permission.enable
  //     ).length

  //     const updatedMiniCards = miniCards.map(card =>
  //       card.id === 2 ? { ...card, text: enabledPermissionGroupsCount } : card
  //     )
  //     console.log(enabledPermissionGroupsCount)
  //     setMiniCards(updatedMiniCards)
  //   }
  // }, [userDetails])

  if (loading) return <Spinners />

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs />
        <Row>
          <Col xl="12">
            <Card className="user_personal_info">
              <CardBody>
                <CardTitle className="mb-4 d-flex align-items-center">
                  <BackButton /> {t("Personal Information")}
                </CardTitle>
                <p className="text-muted mb-4"></p>
                <div className="table-responsive">
                  {Object.values(userDetails).length === 0 ? (
                    <p className="text-center">{t("No user found")}</p>
                  ) : (
                    <Table className="table-nowrap mb-0">
                      <tbody>
                        <tr>
                          <th scope="row">{t("Id")}</th>
                          <td>{userDetails._id}</td>
                        </tr>
                        {/* <tr>
                          <th scope="row">Employee Id</th>
                          <td>{userDetails.employeeId}</td>
                        </tr> */}
                        <tr>
                          <th scope="row">{t("First Name")}</th>
                          <td>{userDetails.firstName || "-"}</td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Last Name")}</th>
                          <td>{userDetails.lastName || "-"}</td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Phone Number")}</th>
                          <td>
                            {userDetails.phoneNumber ? (
                              <LtrText>{userDetails.phoneNumber}</LtrText>
                            ) : (
                              "-"
                            )}
                          </td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Username")}</th>
                          <td>{userDetails.username || "-"}</td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Email")}</th>
                          <td>{userDetails.email || "-"}</td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Role")}</th>
                          <td>{userDetails?.role?.name || "-"}</td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Allow Exports")}</th>
                          <td>
                            {userDetails?.allowExports ? t("Yes") : t("No")}
                          </td>
                        </tr>
                        {/* <tr>
                          <th scope="row">Status</th>
                          <td>{userDetails.firstName}</td>
                        </tr> */}
                      </tbody>
                    </Table>
                  )}
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  )
}

export default ViewUser
